import { TeamMember } from "../../../../models";
import { DataAPI_Base } from "../base";

export class TeamMembersAPI extends DataAPI_Base<TeamMember> {
	constructor() {
		super("team-members");
	}
}
